var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24-triangle/up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 14L12 9.5L16.5 14L7.5 14Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/up.5734207ca230310590ecf484733454ea.svg";